import { createAction, props } from '@ngrx/store';
import { activeDeactiveAgentPayload, agentsListPayload } from './agents.model';

export const fetchAgentsList = createAction('[Data] Fetch Agents List', props<{ payload: agentsListPayload }>());
export const fetchAgentsListSuccess = createAction('[Data] Fetch Agents List Success', props<{ response: any }>());
export const fetchAgentsListFailure = createAction('[Data] Fetch Agents List Failure', props<{ error: string }>());

export const activeDeactiveAgent = createAction('[Data] Active Deactive Agent', props<{ payload: activeDeactiveAgentPayload }>());
export const activeDeactiveAgentSuccess = createAction('[Data] Active Deactive Agent Success', props<{ response: any }>());
export const activeDeactiveAgentFailure = createAction('[Data] Active Deactive Agent Failure', props<{ error: string }>());
